import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Table } from 'antd'
import { useDispatch, useSelector } from 'react-redux';

const Summary = ({questions, answers}) => {
  const dispatch = useDispatch();
  const { 
    index,step } = useSelector((state) => state);
    console.log('index', index)
    console.log('step', step)
  const [summary, setSummary] = useState([])
  const columns = [
    {
      title: 'Question',
      dataIndex: 'question',
      key: 'question',
      render: (text) => <span style={{ color: '#0064A9' }}>{text}</span>,
    }, 
    {
      title: 'Answer',
      dataIndex: 'answer',
      key: 'answer',
    },
  ]
  useEffect(() => {
    const summary = questions.map((question, index) => {
      return {
        question: question.question,
        answer: answers.find(answer => answer.question === question._id).answer
      }
    })
    const dataSource = summary.map((question, index) => {
      return {
        key: index,
        question: question.question,
        answer: question.answer
      }
    })
    setSummary(dataSource)
  }, [answers, questions])

  const handleRowClick = (record) => {

    dispatch({ type: "SET_STEP", step: 0 });
    dispatch({ type: "SET_INDEX", index: record?.key });
   
  };
  return (
        <Table columns={columns} dataSource={summary} pagination={false}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
          style: { cursor: 'pointer' } // Makes it visually clickable
        })}/>
  )
}
Summary.propTypes = {
  questions: PropTypes.array.isRequired,
  answers: PropTypes.array.isRequired,
}

export default Summary
